import React, { Fragment, useState } from 'react';
import XLSX from 'xlsx';
import { find, sum } from 'ramda';
import styled from 'styled-components';
import toast from '~~elements/Toast';
import Button from '~~elements/Button';
import { useTournamentDispatch, useTournamentState } from '../useTournament';
import { updateGameStats } from '../service';
import { recordTypes } from '../Const';

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem 0;
  > button,
  input {
    margin-right: 1rem;
  }
`;

const awayBatterSheetName = 'AWAY 客場 - 打者';
const awayPitcherSheetName = 'AWAY 客場 - 投手';
const homeBatterSheetName = 'HOME 主場 - 打者';
const homePitcherSheetName = 'HOME 主場 - 投手';

const fieldPositionMapping = {
  '1': 'P',
  '2': 'C',
  '3': '1B',
  '4': '2B',
  '5': '3B',
  '6': 'SS',
  '7': 'LF',
  '8': 'CF',
  '9': 'RF',
  DH: 'DH',
  PR: 'PR',
  PH: 'PH',
};

const getCellValue = (cell, defaultValue = '') => {
  if (!cell?.v && cell?.v !== 0) {
    return defaultValue;
  }
  return cell.v.toString();
};

const defaultZero = (value) => {
  value = parseInt(value);
  if (Number.isNaN(value)) {
    return 0;
  }

  return value;
};

const BoxScoreUpload = ({ awayTeamPlayers, homeTeamPlayers, gameWithPlayers }) => {
  const tournamentDispatch = useTournamentDispatch();
  const { tournamentInfo } = useTournamentState();

  const [parsedData, setParsedData] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [inputRefresh, setInputRefresh] = useState(0);

  const errorToast = (message) => {
    toast(message, {
      status: 'error',
      second: 3,
    });
    setInputRefresh((pre) => ++pre);
  };

  const handleFileOnChange = (e) => {
    e.preventDefault();
    setParsedData(null);
    const files = e.target.files;
    if (files.length !== 1) {
      return;
    }

    // toast('讀取中，請稍後', {
    //   status: 'info',
    // });

    const file = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const awayBatters = workbook.Sheets[awayBatterSheetName];
      const awayPitchers = workbook.Sheets[awayPitcherSheetName];
      const homeBatters = workbook.Sheets[homeBatterSheetName];
      const homePitchers = workbook.Sheets[homePitcherSheetName];

      if (!awayBatters || !awayPitchers || !homeBatters || !homePitchers) {
        errorToast(
          `格式錯誤，應包含 ${awayBatterSheetName} ${awayPitcherSheetName} ${homeBatterSheetName} ${homePitcherSheetName} 表單`,
        );
        return;
      }

      const awayGetPlayer = (number) => {
        return find((p) => p.number === number, awayTeamPlayers);
      };
      const homeGetPlayer = (number) => {
        return find((p) => p.number === number, homeTeamPlayers);
      };

      const batterPitcherValidate = (side, batters, opponentPitchers) => {
        console.log(batters);
        console.log(opponentPitchers);
        const shouldEqualColumns = [
          { batter: 'PA', pitcher: 'BF', display: '打席' },
          { batter: 'H', pitcher: 'H', display: '（被）安打' },
          { batter: 'HR', pitcher: 'HR', display: '（被）全壘打' },
          { batter: 'BB', pitcher: 'BB', display: '四死球' },
          { batter: 'IBB', pitcher: 'IBB', display: '故意四死球' },
          { batter: 'HBP', pitcher: 'HB', display: '觸身球' },
          { batter: 'SO', pitcher: 'SO', display: '（被）三振' },
          { batter: 'R', pitcher: 'R', display: '得/失分' },
        ];

        for (let column of shouldEqualColumns) {
          if (
            sum(batters.map((b) => parseInt(b[column.batter]))) !==
            sum(opponentPitchers.map((b) => parseInt(b[column.pitcher])))
          ) {
            errorToast(`${side}打者與對手投手 ${column.display}數 加總不同`);
            return false;
          }
        }

        return true;
      };

      const {
        batters: awayBatterStatistics,
        fielders: awayFielderStatistics,
        records: awayRecords,
        error: awayStatisticsError,
      } = parsePAStatistics({
        sheet: awayBatters,
        getPlayer: awayGetPlayer,
        sheetName: awayBatterSheetName,
      });
      if (awayStatisticsError) {
        return;
      }

      const { pitchers: awayPitcherStatistics, error: awayPitcherError } = parsePitcherStatistics({
        sheet: awayPitchers,
        getPlayer: awayGetPlayer,
        sheetName: awayPitcherSheetName,
      });
      if (awayPitcherError) {
        return;
      }

      const {
        batters: homeBatterStatistics,
        fielders: homeFielderStatistics,
        records: homeRecords,
        error: homeStatisticsError,
      } = parsePAStatistics({
        sheet: homeBatters,
        getPlayer: homeGetPlayer,
        sheetName: homeBatterSheetName,
      });
      if (homeStatisticsError) {
        return;
      }

      const { pitchers: homePitcherStatistics, error: homePitcherError } = parsePitcherStatistics({
        sheet: homePitchers,
        getPlayer: homeGetPlayer,
        sheetName: homePitcherSheetName,
      });
      if (homePitcherError) {
        return;
      }

      if (
        !batterPitcherValidate('客場', awayBatterStatistics, homePitcherStatistics) ||
        !batterPitcherValidate('主場', homeBatterStatistics, awayPitcherStatistics)
      ) {
        return;
      }

      console.log(awayBatterStatistics);
      console.log(awayFielderStatistics);
      console.log(awayRecords);
      console.log(awayPitcherStatistics);

      console.log(homeBatterStatistics);
      console.log(homeFielderStatistics);
      console.log(homeRecords);
      console.log(homePitcherStatistics);
      toast('檔案分析成功！點擊送出進行更新', {
        status: 'success',
      });

      setParsedData({
        away: {
          batters: awayBatterStatistics,
          pitchers: awayPitcherStatistics,
          players: awayFielderStatistics,
          records: awayRecords,
        },
        home: {
          batters: homeBatterStatistics,
          pitchers: homePitcherStatistics,
          players: homeFielderStatistics,
          records: homeRecords,
        },
      });
    };
    reader.readAsArrayBuffer(file);
  };

  const parsePAStatistics = ({ sheet, getPlayer, sheetName }) => {
    const PAOrder = {};
    let PATotal = 0;
    const batters = [];
    const fielders = [];
    const records = [];

    let seq = 1;
    let emptyTolerant = 2; // 一般紀錄單一個打席會有三行，假設無腦記下來中間可以接受空兩行（至少一個打序會有一個人在打）
    while (getCellValue(sheet[`B${seq + 1}`]).trim() || emptyTolerant > 0) {
      seq++;

      const playerNumber = getCellValue(sheet[`B${seq}`]);
      if (!playerNumber) {
        if (emptyTolerant > 0) {
          emptyTolerant--;
          continue;
        }

        errorToast(`${sheetName} B${seq} 格式錯誤，選手背號為必填`);
        return { error: true };
      }
      emptyTolerant = 2;

      const player = getPlayer(playerNumber);
      if (!player) {
        errorToast(`${sheetName} B${seq} 格式錯誤，找不到背號 ${playerNumber} 的球員`);
        return { error: true };
      }

      const order = parseInt(getCellValue(sheet[`C${seq}`]));
      const positions = getCellValue(sheet[`D${seq}`]).split(',');
      const positionLength = positions.length;
      if (positionLength < 1) {
        errorToast(`${sheetName} D${seq} 格式錯誤，至少要有一個守位（用 , 區分）`);
        return { error: true };
      }
      for (let position of positions) {
        if (!['1', '2', '3', '4', '5', '6', '7', '8', '9', 'DH', 'PH', 'PR'].includes(position)) {
          errorToast(`${sheetName} D${seq} 格式錯誤，包含無法辨識之守位（1 - 9 DH PR PH）`);
          return { error: true };
        }
      }

      if (Number.isNaN(order) && (positionLength !== 1 || positions[0] !== '1')) {
        errorToast(`${sheetName} C${seq} D${seq} 格式錯誤，無棒次選手只能是投手`);
        return { error: true };
      }

      // 單場紀錄
      const playerRecords = getCellValue(sheet[`J${seq}`]).split(',');
      for (let playerRecord of playerRecords) {
        if (!playerRecord) {
          continue;
        }
        const [playerValue, playerCommnet] = playerRecord.split(':');

        let player_type = '';
        let value = playerValue;
        const comment = playerCommnet ? playerCommnet : '';
        switch (playerValue) {
          case 'B_MVP':
            player_type = 'BATTER';
            value = 'MVP';
            break;
          case 'B_SP_RECORD':
            player_type = 'BATTER';
            value = 'SP_RECORD';
            break;
          case 'P_MVP':
            player_type = 'PITCHER';
            value = 'MVP';
            break;
          case 'P_SP_RECORD':
            player_type = 'PITCHER';
            value = 'SP_RECORD';
            break;
          default:
            if (find((br) => br === playerValue, recordTypes.BATTER)) {
              player_type = 'BATTER';
            } else if (find((pr) => pr === playerValue, recordTypes.PITCHER)) {
              player_type = 'PITCHER';
            }
            break;
        }

        if (player_type === '') {
          errorToast(`${sheetName} J${seq} 格式錯誤，無法分析單場紀錄 ${playerRecord}`);
          return { error: true };
        }

        records.push({
          player: { name: player.name, number: player.number, uniqid: player.uniqid },
          player_type,
          value,
          comment,
        });
      }

      // 守備資訊
      const POs = getCellValue(sheet[`K${seq}`]).split(',');
      const As = getCellValue(sheet[`L${seq}`]).split(',');
      const Es = getCellValue(sheet[`M${seq}`]).split(',');
      const DPs = getCellValue(sheet[`N${seq}`]).split(',');
      const PBs = getCellValue(sheet[`P${seq}`]).split(',');
      const SBs = getCellValue(sheet[`Q${seq}`]).split(',');
      const CSs = getCellValue(sheet[`R${seq}`]).split(',');
      const fielder = { info: { name: player.name, number: player.number, uniqid: player.uniqid }, fieldings: [] };
      positions.forEach((position, index) => {
        const fielding = {
          position: fieldPositionMapping[position],
          order: index + 1,
          PO: POs[index] ? defaultZero(POs[index]) : 0,
          A: As[index] ? defaultZero(As[index]) : 0,
          E: Es[index] ? defaultZero(Es[index]) : 0,
          DP: DPs[index] ? defaultZero(DPs[index]) : 0,
          PB: PBs[index] ? defaultZero(PBs[index]) : 0,
          SB: SBs[index] ? defaultZero(SBs[index]) : 0,
          CS: CSs[index] ? defaultZero(CSs[index]) : 0,
        };
        fielding.TC = fielding.PO + fielding.A + fielding.E;
        fielder.fieldings.push(fielding);
      });
      fielders.push(fielder);

      if (Number.isNaN(order)) {
        continue;
      }

      if (1 > order || order > 9) {
        errorToast(`${sheetName} C${seq} 格式錯誤，打者僅能包含 1 - 9 棒`);
        return { error: true };
      }

      // 打者資訊
      const statistics = {
        player: { name: player.name, number: player.number, uniqid: player.uniqid },
        order: order,
        is_PH: !!PAOrder[order],
        PA: defaultZero(getCellValue(sheet[`E${seq}`], '0')),
        AB: 0,
        H: 0,
        TWOB: 0,
        THREEB: 0,
        HR: 0,
        SO: 0,
        BB: 0,
        IBB: 0,
        HBP: 0,
        SF: 0,
        SH: 0,
        GIDP: 0,
        FC: 0,
        E: 0,
        FO: 0,
        GO: 0,
        R: defaultZero(getCellValue(sheet[`F${seq}`], '0')),
        RBI: defaultZero(getCellValue(sheet[`G${seq}`], '0')),
        SB: defaultZero(getCellValue(sheet[`H${seq}`], '0')),
        CS: defaultZero(getCellValue(sheet[`I${seq}`], '0')),
      };

      batters.push(statistics);
      const batterIndex = batters.length - 1;

      const PA = Number.isNaN(parseInt(statistics.PA)) ? 0 : parseInt(statistics.PA);
      if (PA === 0) {
        continue;
      }

      PATotal += PA;
      if (!PAOrder[order]) {
        PAOrder[order] = [];
      }

      for (let i = 0; i < PA; i++) {
        PAOrder[order].push(batterIndex);
      }
    }

    // 將打席結果對應至打者中
    const maxParsingColumns = 50;
    const possiblePAColumn = ['U', 'V', 'W', 'X', 'Y', 'Z'];
    for (let j = 'A'.charCodeAt(0); j <= 'Z'.charCodeAt(0); j++) {
      for (let k = 'A'.charCodeAt(0); k <= 'Z'.charCodeAt(0); k++) {
        possiblePAColumn.push(String.fromCharCode(j) + String.fromCharCode(k));
        if (possiblePAColumn.length > maxParsingColumns) {
          break;
        }
      }
      if (possiblePAColumn.length > maxParsingColumns) {
        break;
      }
    }
    const PAResultList = [];
    let startFrom = 1;
    for (let PAColumn of possiblePAColumn) {
      let includeOnPAResult = false;
      for (let i = 1; i <= 9; i++) {
        let rowNumber = (startFrom % 9) + 1;
        if (rowNumber === 1) {
          rowNumber = 10;
        }

        const PAResult = getCellValue(sheet[`${PAColumn}${rowNumber}`]);
        if (!PAResult) {
          break;
        }

        includeOnPAResult = true;
        PAResultList.push(PAResult);
        startFrom++;
      }

      if (!includeOnPAResult) {
        break;
      }
    }

    if (PAResultList.length !== PATotal) {
      errorToast(`${sheetName} 打席結果總 PA 數與打者總 PA 數不符`);
      return { error: true };
    }

    const addOne = (origin) => {
      return origin + 1;
    };

    console.log(PAResultList);
    let PAResultError = false;
    PAResultList.forEach((PAResult, index) => {
      const round = Math.floor(index / 9);
      const order = (index + 1) % 9 === 0 ? 9 : (index + 1) % 9;
      const batter = batters[PAOrder[order][round]];

      if (!batter) {
        errorToast(`${sheetName} 第${order}棒打席數有誤，無法匹配打席結果`);
        PAResultError = true;
        return;
      }

      switch (PAResult) {
        case '1B':
          batter.H = addOne(batter.H);
          batter.AB = addOne(batter.AB);
          break;
        case '2B':
          batter.H = addOne(batter.H);
          batter.TWOB = addOne(batter.TWOB);
          batter.AB = addOne(batter.AB);
          break;
        case '3B':
          batter.H = addOne(batter.H);
          batter.THREEB = addOne(batter.THREEB);
          batter.AB = addOne(batter.AB);
          break;
        case 'HR':
          batter.H = addOne(batter.H);
          batter.HR = addOne(batter.HR);
          batter.AB = addOne(batter.AB);
          break;
        case 'SH':
        case 'SF':
        case 'HBP':
          batter[PAResult] = addOne(batter[PAResult]);
          break;
        case 'IBB':
          batter.IBB = addOne(batter.IBB);
        // fallthrough
        case 'uBB':
          batter.BB = addOne(batter.BB);
          break;
        default:
          // 不記錄且無打數
          if (['IR', 'IH'].includes(PAResult)) {
            break;
          }

          // 不記錄但有打數
          if (['ID'].includes(PAResult)) {
            batter.AB = addOne(batter.AB);
            break;
          }

          if (!['E', 'FC', 'GO', 'FO', 'GIDP', 'SO'].includes(PAResult)) {
            errorToast(`${sheetName} 第${round}輪第${order}棒打席結果有誤，無對應代號`);
            PAResultError = true;
            return;
          }

          // 正常加結果加打數
          batter[PAResult] = addOne(batter[PAResult]);
          batter.AB = addOne(batter.AB);
          break;
      }
    });
    if (PAResultError) {
      return { error: true };
    }

    return { batters, fielders, records, error: false };
  };

  const parsePitcherStatistics = ({ sheet, getPlayer, sheetName }) => {
    const pitchers = [];

    let seq = 1;
    while (getCellValue(sheet[`B${seq + 1}`]).trim()) {
      seq++;

      const playerNumber = getCellValue(sheet[`B${seq}`]);
      if (!playerNumber) {
        errorToast(`${sheetName} B${seq} 格式錯誤，選手背號為必填`);
        return { error: true };
      }

      const pitcher = getPlayer(playerNumber);
      if (!pitcher) {
        errorToast(`${sheetName} B${seq} 格式錯誤，找不到背號 ${playerNumber} 的球員`);
        return { error: true };
      }

      pitchers.push({
        player: { name: pitcher.name, number: pitcher.number, uniqid: pitcher.uniqid },
        order: pitchers.length + 1,
        IPOut: defaultZero(getCellValue(sheet[`C${seq}`], '0')),
        NP: defaultZero(getCellValue(sheet[`D${seq}`], '0')),
        BF: defaultZero(getCellValue(sheet[`E${seq}`], '0')),
        H: defaultZero(getCellValue(sheet[`F${seq}`], '0')),
        HR: defaultZero(getCellValue(sheet[`G${seq}`], '0')),
        BB: defaultZero(getCellValue(sheet[`H${seq}`], '0')),
        IBB: defaultZero(getCellValue(sheet[`I${seq}`], '0')),
        HB: defaultZero(getCellValue(sheet[`J${seq}`], '0')),
        SO: defaultZero(getCellValue(sheet[`K${seq}`], '0')),
        WP: defaultZero(getCellValue(sheet[`L${seq}`], '0')),
        BK: defaultZero(getCellValue(sheet[`M${seq}`], '0')),
        R: defaultZero(getCellValue(sheet[`N${seq}`], '0')),
        ER: defaultZero(getCellValue(sheet[`O${seq}`], '0')),
      });
    }

    return { pitchers, error: false };
  };

  const updateBoxScore = () => {
    setUploading(true);
    updateGameStats(tournamentInfo.uniqid, gameWithPlayers.uniqid, {
      ...parsedData.away,
      side: 'AWAY',
    })
      .then(() => {
        updateGameStats(tournamentInfo.uniqid, gameWithPlayers.uniqid, {
          ...parsedData.home,
          side: 'HOME',
        }).then((newGameDataWithPlayers) => {
          tournamentDispatch({
            type: 'UPDATE_GAME',
            payload: {
              ...newGameDataWithPlayers,
            },
          });
          toast('更新成功！請至客/主場數據確認', { status: 'success' });
          setParsedData(null);
          setUploading(false);
        });
      })
      .catch((e) => {
        errorToast(`發生錯誤：${e.toString()}，請重新整理後再試一遍`);
        setUploading(false);
      });
  };

  const cleanParsedData = () => {
    setParsedData(null);
  };

  if (gameWithPlayers.info.status !== 'FINISHED') {
    return <label>比賽需結束</label>;
  }

  if (gameWithPlayers.away.record_pbp || gameWithPlayers.home.record_pbp) {
    return <label>已上傳逐打席數據</label>;
  }

  return (
    <StyledDiv>
      {!parsedData ? (
        <input type="file" accept=".xlsx,.xls" multiple={false} onChange={handleFileOnChange} key={inputRefresh} />
      ) : (
        <Fragment>
          <Button width="unset" color="red" onClick={updateBoxScore} disabled={uploading}>
            送出
          </Button>
          <Button width="unset" color="transparentWithBorder" onClick={cleanParsedData} disabled={uploading}>
            取消
          </Button>
        </Fragment>
      )}
    </StyledDiv>
  );
};

export default BoxScoreUpload;
